<template>
      <div class="card h-100 shadow-sm">
      
          <div class="card-body">
            <h5 class="card-title fw-semibold fs-5">{{ card.title }}</h5>
                  <!-- Optional image -->
            <slot name="image"></slot>
           <!-- <h6 class="card-subtitle mb-2 text-muted fs-6">{{ card.subtitle }}</h6> -->
            <br> <br>
            <p class="card-text fs-6 lh-base">{{ card.description }}</p>
        
          </div>
           <div class="card-footer bg-transparent border-top-0">
             <!-- Optional add button here -->
        
          </div>
        </div>
        <br>
</template>

<script>


export default {
  props: ['card'],
    //title: String,
    //subtitle: String,
    //text: String,
  
  methods: {}
};
</script>


<style scoped>
.card-title {
  font-weight: bold;
}


.card {
  border: 1px solid #d4eadd;
  background-color: #f9fdfb; /* light green background */
  max-width: 500px;
  margin: 0 auto;
  margin-bottom: 20px;

}


.container {
  border-left: 2px solid #ddd;
  padding-left: 20px;
}

.card-title {
  color: #1e5f3d; /* dark green */
  font-weight: bold;
}

.card-text {
  color: #333;
}

.badge {
  background-color: #198754; /* Bootstrap's success green */
}

.btn-custom {
  background-color: #198754; /* Green */
  color: white;
  border: 2px solid #198754;
  transition: all 0.3s ease;
}

.btn-custom:hover {
  background-color: white;
  color: #198754;
  border: 2px solid #198754;
}



</style>